import React from 'react'
import styled from 'styled-components'
import LazyLoad from 'react-lazyload'
import { createResource, useResource } from '@/lib/i18n'
import { useWindowSize } from '@/lib/use-hooks/use-window-size'

const resource = createResource({
  en: {
    title: `Recruitment Process`,
  },
  id: {
    title: 'Recruitment Process',
  },
})

const ProcessVideo = () => {
  const { t } = useResource(resource)
  const { width } = useWindowSize()

  return (
    <BannerBox>
      <div className="container">
        <div className="title">{t('title')}</div>
        <div className="video-box">
          <LazyLoad>
            <iframe
              loading="lazy"
              className="video-real"
              width={width > 1000 ? 852 : 280}
              height={width > 1000 ? 480 : 158}
              src="https://www.youtube.com/embed/mVJOL18McDo"
              frameBorder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </LazyLoad>
        </div>
      </div>
    </BannerBox>
  )
}

export default ProcessVideo

const BannerBox = styled.div`
  @media only screen and (max-width: 1000px) {
    margin-top: 62px;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      position: relative;
      width: 100%;
      margin: 0 auto;
      padding: 0 24px;
      .title {
        font-size: 24px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 28px;
        text-align: center;
      }
      .video-box {
        display: flex;
        margin-top: 24px;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 320px;
        height: 180px;
        background-image: url('/images/career/video-bg.png');
        background-size: 106% auto;
        background-repeat: no-repeat;
        background-position: bottom;
        .video-real {
          margin: 0 auto;
        }
      }
    }
  }
  @media only screen and (min-width: 1000px) {
    max-width: 1440px;
    margin: 0 auto;
    background-size: 100% 100%;
    background-repeat: no-repeat;
    .container {
      width: 100%;
      max-width: 1440px;
      padding: 0 150px;
      .title::before {
        content: '-';
        background: #1cc812;
        color: transparent;
        margin-right: 16px;
      }
      .title {
        font-size: 32px;
        font-family: Roboto-Medium, Roboto;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.87);
        line-height: 36px;
      }
      .video-box {
        display: flex;
        margin: 30px auto 0;
        flex-direction: column;
        justify-content: center;
        align-items: flex-end;
        width: 1066px;
        height: 510px;
        background-image: url('/images/career/video-bg.png');
        background-size: 100% auto;
        background-repeat: no-repeat;
        background-position: bottom;
        .video-real {
          margin: 0 auto;
        }
      }
    }
  }
`
